"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NeteAGrupoPoseidN() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="5061" id="únete-a-grupo-poseidón" className="relative overflow-hidden py-32 md:py-40 bg-background text-foreground">
      {}
      <svg className="pointer-events-none absolute bottom-8 right-6 md:bottom-12 md:right-16 h-32 w-32 md:h-48 md:w-48 opacity-20" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M180 20 C 140 40, 120 80, 130 120 C 140 160, 100 180, 60 170 C 40 165, 25 150, 20 130" stroke="hsl(45 100% 52%)" strokeWidth="1" strokeLinecap="round" fill="none" />
        <path d="M130 120 C 145 115, 155 105, 158 92" stroke="hsl(45 100% 52%)" strokeWidth="1" strokeLinecap="round" fill="none" />
        <path d="M60 170 C 55 155, 50 145, 40 138" stroke="hsl(45 100% 52%)" strokeWidth="1" strokeLinecap="round" fill="none" />
      </svg>

      <div className="mx-auto max-w-6xl px-6 md:px-10">
        {}
        <h2 ref={headlineRef} className={`font-default font-bold leading-[1.1] tracking-tighter text-foreground text-5xl sm:text-6xl md:text-7xl lg:text-8xl max-w-[70%] transition-all duration-1000 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          Proteja su{" "}
          <span className="font-default font-bold" style={{
          color: "hsl(45 100% 52%)",
          display: "inline-block",
          letterSpacing: "-0.02em"
        }}>
            patrimonio.
          </span>
        </h2>

        {}
        <div ref={bodyRef} className={`mt-12 md:mt-16 md:ml-[15%] transition-all duration-1000 delay-200 ease-out ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        maxWidth: "45ch"
      }}>
          <p className="font-default text-lg md:text-xl leading-relaxed text-muted-foreground">
            Ya sea que necesite vigilancia corporativa de élite o un sistema de monitoreo tecnológico avanzado, le invitamos a iniciar una conversación estratégica sobre su seguridad.
          </p>
        </div>

        {}
        <div ref={ctaRef} className={`mt-12 md:mt-14 md:ml-[15%] flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-10 transition-all duration-1000 delay-300 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Button asChild className="group bg-primary text-primary-foreground hover:bg-primary/90 rounded-md font-default text-base md:text-lg font-semibold shadow-lg" style={{
          padding: "1.25rem 3rem",
          height: "auto"
        }}>
            <Link to="/ContactPage">
              <span>Solicitar Cotización</span>
              <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>

          <Link to="tel:+525550000000" className="font-default text-base md:text-lg text-foreground/80 hover:text-primary transition-colors border-b border-primary pb-1 self-start sm:self-auto">
            O llame al +52 55 POSEIDON
          </Link>
        </div>
      </div>
    </section>;
}